import { Auth } from "aws-amplify";

const authenticationService = {
  getCurrentUser,
  getToken,
  getTokenLocal,
  signOut,
  currentUser,
};

async function getCurrentUser() {
  const authUser = await Auth.currentUserInfo();
  sessionStorage.setItem("user", JSON.stringify(authUser));

  return authUser;
}

async function getToken() {
  const token = await Auth.currentSession();
  const accessToken = token.getAccessToken();
  const jwt = accessToken.getJwtToken();

  sessionStorage.setItem("token", jwt);

  return jwt;
}

function getTokenLocal() {
  return sessionStorage.getItem("token");
}

async function signOut() {
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("token");

  return await Auth.signOut();
}

function currentUser() {
  let user = sessionStorage.getItem("user");

  if (user && user.length) {
    user = JSON.parse(user);
  }

  return user;
}

export default authenticationService;
